(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dp-faq-hub"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dp-faq-browser')) {
  customElements.define('dp-faq-browser', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.scope = this.closest('main');
      this.input = this.querySelector('[data-faq-search]');
      this.topic = this.querySelector('[data-faq-topic]');
      this.counter = this.querySelector('[data-faq-count]');
      if (!this.scope || !this.input || !this.topic) return;
      this.querySelector('form').addEventListener('submit', event => event.preventDefault(), options);
      this.input.addEventListener('input', () => this.filter(), options);
      this.topic.addEventListener('change', () => this.filter(), options);
      this.querySelectorAll('[data-faq-clear], [data-faq-reset]').forEach(button => button.addEventListener('click', () => { this.input.value = ''; this.topic.value = 'all'; this.filter(); this.input.focus(); }, options));
      document.addEventListener('shopify:section:load', () => this.refresh(), options);
      document.addEventListener('shopify:section:unload', () => requestAnimationFrame(() => { if (this.isConnected) this.refresh(); }), options);
      document.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('[data-faq-item]');
        if (item && this.scope.contains(item)) { this.input.value = ''; this.topic.value = 'all'; this.filter(); item.open = true; }
      }, options);
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.refresh(), { once: true, signal: this.controller.signal });
      else this.refresh();
    }
    normalize(value) { return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[’']/g, ''); }
    refresh() {
      if (!this.scope) return;
      const selected = this.topic.value;
      this.topic.querySelectorAll('option:not(:first-child)').forEach(option => option.remove());
      this.groups = [...this.scope.querySelectorAll('[data-dp-faq-group]')].map(element => {
        const key = element.id;
        const label = element.dataset.faqLabel;
        this.topic.add(new Option(label, key));
        return { element, key, items: [...element.querySelectorAll('[data-faq-item]')].map(item => ({ element: item, text: this.normalize(label + ' ' + item.textContent) })) };
      });
      this.topic.value = this.groups.some(group => group.key === selected) ? selected : 'all';
      this.querySelector('[data-faq-tools]').hidden = this.groups.length === 0;
      this.filter();
    }
    filter() {
      if (!this.groups) return;
      const words = this.normalize(this.input.value.trim()).split(/\s+/).filter(Boolean);
      let count = 0;
      this.groups.forEach(group => {
        let groupCount = 0;
        group.items.forEach(item => {
          const matches = (this.topic.value === 'all' || this.topic.value === group.key) && words.every(word => item.text.includes(word));
          item.element.hidden = !matches;
          if (!matches) item.element.open = false;
          if (matches) groupCount++;
        });
        group.element.hidden = groupCount === 0;
        count += groupCount;
      });
      this.counter.textContent = (count === 1 ? this.counter.dataset.one : this.counter.dataset.many).replace('[count]', String(count));
      this.querySelector('[data-faq-empty]').hidden = count > 0;
      this.querySelector('[data-faq-clear]').hidden = words.length === 0 && this.topic.value === 'all';
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-home-header"]) return;
  try {
    
  if (!customElements.get('dp-home-header')) {
    customElements.define('dp-home-header', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('click', event => {
          const summary = event.target.closest('summary');
          if (summary) this.querySelectorAll('details[open]').forEach(details => { if (details !== summary.parentElement) details.open = false; });
          if (event.target.closest('a')) this.querySelectorAll('details[open]').forEach(details => { details.open = false; });
        }, options);
        document.addEventListener('click', event => { if (!this.contains(event.target)) this.querySelectorAll('details[open]').forEach(details => { details.open = false; }); }, options);
        this.addEventListener('keydown', event => { if (event.key === 'Escape') { const details = event.target.closest('details[open]'); if (details) { details.open = false; details.querySelector('summary').focus(); } } }, options);
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-service-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dp-service-directory')) {
    customElements.define('dp-service-directory', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.form = this.querySelector('[data-controls]');
        this.source = this.querySelector('[data-source]');
        this.results = this.querySelector('[data-results]');
        this.status = this.querySelector('[data-status]');
        this.items = new Map();
        this.size = 12;
        this.page = 1;
        this.collect(this);
        this.form.hidden = false;
        this.querySelector('[data-status-wrap]').hidden = false;
        this.querySelectorAll('[data-kind-preset]').forEach(button => button.addEventListener('click', () => { if (this.dataset.ready !== 'true') return; this.form.reset(); this.form.elements.area_kind.value = button.dataset.kindPreset; this.counties(); this.change(); }, { signal: this.controller.signal }));
        const options = { signal: this.controller.signal };
        this.form.addEventListener('submit', event => event.preventDefault(), options);
        this.form.addEventListener('input', event => {
          if (event.target.name !== 'area_q') return;
          clearTimeout(this.searchTimer);
          this.searchTimer = setTimeout(() => this.change(), 120);
        }, options);
        this.form.addEventListener('change', event => {
          if (event.target.name === 'area_region') this.counties();
          this.change();
        }, options);
        this.querySelectorAll('[data-reset]').forEach(button => button.addEventListener('click', () => {
          this.form.reset(); this.counties(); this.change(); this.form.elements.area_q.focus();
        }, options));
        this.querySelector('[data-prev]').addEventListener('click', () => this.move(-1), options);
        this.querySelector('[data-next-page]').addEventListener('click', () => this.move(1), options);
        this.querySelector('[data-retry]').addEventListener('click', () => this.load(), options);
        window.addEventListener('popstate', () => { if (this.dataset.ready === 'true') { this.readState(); this.render(); } }, options);
        this.load();
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; clearTimeout(this.searchTimer); }
      collect(root) {
        root.querySelectorAll('[data-area]').forEach(node => {
          const copy = node.cloneNode(true), d = copy.dataset;
          this.items.set(d.key, { node: copy, name: d.name, region: d.region, county: d.county, kind: d.kind, search: this.normalize([d.name,d.region,d.county,d.kind,d.search].join(' ')) });
        });
      }
      normalize(value) { return value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
      async load() {
        this.dataset.ready = 'false';
        [...this.form.elements].forEach(field => field.disabled = true);
        this.status.textContent = this.dataset.loadingLabel;
        this.querySelector('[data-retry]').hidden = true;
        const seen = new Set();
        try {
          let next = this.source.dataset.next;
          if (Number(this.source.dataset.currentPage) > 1) {
            const first = new URL(window.location.href); first.searchParams.set(this.source.dataset.pageParam || 'page', '1'); next = first.href;
          }
          while (next) {
            const url = new URL(next, window.location.href);
            if (url.origin !== window.location.origin) throw new Error('Invalid directory origin');
            for (const key of ['view','preview_theme_id']) {
              const value = new URL(window.location.href).searchParams.get(key);
              if (value) url.searchParams.set(key, value);
            }
            url.searchParams.set('section_id', this.dataset.sectionId);
            if (seen.has(url.href)) throw new Error('Repeated directory page');
            seen.add(url.href);
            const response = await fetch(url.href, { signal: this.controller.signal, credentials: 'same-origin' });
            if (!response.ok) throw new Error('Directory page unavailable');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const section = doc.querySelector('dp-service-directory');
            const source = section?.querySelector('[data-source]');
            if (!source) throw new Error('Missing directory content');
            this.collect(section); next = source.dataset.next;
          }
          if (!this.isConnected) return;
          this.all = [...this.items.values()].sort((a,b) => Number(a.kind === 'Relocation route') - Number(b.kind === 'Relocation route') || a.region.localeCompare(b.region) || a.name.localeCompare(b.name));
          this.populate('area_region', this.all.map(item => item.region));
          this.readState();
          [...this.form.elements].forEach(field => field.disabled = false);
          this.querySelector('[data-server-pages]')?.setAttribute('hidden','');
          this.dataset.ready = 'true';
          this.querySelector('[data-type-presets]').hidden = false;
          this.querySelectorAll('[data-kind-count]').forEach(node => { const kind = node.dataset.kindCount; node.textContent = String(this.all.filter(item => !kind || item.kind === kind).length); });
          this.render();
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.status.textContent = this.dataset.errorLabel;
          this.querySelector('[data-retry]').hidden = false;
        }
      }
      populate(name, values) {
        const select = this.form.elements[name], current = select.value;
        while (select.options.length > 1) select.remove(1);
        [...new Set(values.filter(Boolean))].sort((a,b) => a.localeCompare(b)).forEach(value => select.add(new Option(value, value)));
        select.value = [...select.options].some(option => option.value === current) ? current : '';
      }
      counties() {
        const region = this.form.elements.area_region.value;
        this.populate('area_county', this.all.filter(item => !region || item.region === region).map(item => item.county));
      }
      readState() {
        const params = new URL(window.location.href).searchParams;
        for (const name of ['area_q','area_region','area_kind']) this.form.elements[name].value = params.get(name) || '';
        this.counties(); this.form.elements.area_county.value = params.get('area_county') || '';
        this.page = Math.max(1, Number.parseInt(params.get('area_page'),10) || 1);
      }
      writeState() {
        const url = new URL(window.location.href);
        for (const name of ['area_q','area_region','area_county','area_kind']) {
          const value = this.form.elements[name].value.trim();
          if (value) url.searchParams.set(name,value); else url.searchParams.delete(name);
        }
        if (this.page > 1) url.searchParams.set('area_page',String(this.page)); else url.searchParams.delete('area_page');
        history.replaceState(null,'',url);
      }
      change() { if (this.dataset.ready !== 'true') return; this.page = 1; this.render(); this.writeState(); }
      move(offset) { this.page += offset; this.render(); this.writeState(); this.results.focus({preventScroll:true}); this.results.scrollIntoView({block:'start'}); }
      render() {
        const fields = this.form.elements, words = this.normalize(fields.area_q.value).split(' ').filter(Boolean);
        const isRoute = fields.area_kind.value === 'Relocation route';
        fields.area_county.disabled = isRoute;
        fields.area_region.disabled = isRoute;
        if (isRoute) { fields.area_county.value = ''; fields.area_region.value = ''; }
        this.querySelectorAll('[data-kind-preset]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.kindPreset === fields.area_kind.value))); 
        const filtered = this.all.filter(item => (!fields.area_region.value || item.region === fields.area_region.value) && (!fields.area_county.value || item.county === fields.area_county.value) && (!fields.area_kind.value || item.kind === fields.area_kind.value) && words.every(word => item.search.includes(word)));
        const pages = Math.max(1,Math.ceil(filtered.length / this.size)); this.page = Math.min(pages,Math.max(1,this.page));
        const start = (this.page - 1) * this.size, visible = filtered.slice(start,start+this.size), groups = new Map();
        visible.forEach(item => { if (!groups.has(item.region)) groups.set(item.region,[]); groups.get(item.region).push(item); });
        const fragment = document.createDocumentFragment();
        groups.forEach((items,region) => {
          const group = document.createElement('section'); group.className = 'dp-directory-group';
          const heading = document.createElement('h2'); heading.textContent = region;
          const list = document.createElement('ul'); list.className = 'dp-directory-cards'; list.setAttribute('role','list');
          items.forEach(item => list.append(item.node.cloneNode(true))); group.append(heading,list); fragment.append(group);
        });
        this.results.replaceChildren(fragment);
        this.querySelector('[data-empty]').hidden = filtered.length !== 0;
        this.status.textContent = this.dataset.resultTemplate.replace('__START__',filtered.length ? String(start+1) : '0').replace('__END__',String(Math.min(start+this.size,filtered.length))).replace('__TOTAL__',String(filtered.length));
        this.querySelector('[data-pages]').hidden = pages <= 1;
        this.querySelector('[data-prev]').disabled = this.page <= 1;
        this.querySelector('[data-next-page]').disabled = this.page >= pages;
        this.querySelector('[data-page-label]').textContent = this.dataset.pageTemplate.replace('__PAGE__',String(this.page)).replace('__PAGES__',String(pages));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-special-projects"] && !Shopify.designMode) return;
  try {
    
if (!window.dpSpecialProjectsBound) {
  window.dpSpecialProjectsBound = true;
  document.addEventListener('click', function(event) {
    var link = event.target.closest('[data-dp-special-type]');
    if (!link) return;
    var root = link.closest('.dp-special-page');
    var select = root && root.querySelector('[data-dp-special-select]');
    if (!select) return;
    var option = Array.from(select.options).find(function(item) { return item.dataset.type === link.dataset.dpSpecialType; });
    if (option) { select.value = option.value; select.dispatchEvent(new Event('change', { bubbles: true })); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
